import React, { useCallback } from "react";
import { LoadingButton } from "@mui/lab";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import RightTickIcon from "../../../assets/Icon/RightTickIcon";
import { useTranslation } from "react-i18next";

const CancelReservationSuccessModal = ({ isOpen, onCancel, onSubmit }) => {
  const onConfirmClick = useCallback(() => {
    onSubmit();
  }, [onSubmit]);
  const { t } = useTranslation();

  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={isOpen}
    >
      <Box
        sx={{
          background: "white",
          width: "480px",
          maxWidth: "95vw",
          p: 2,
          borderRadius: 1,
          justifyContent: "center",
        }}
      >
        <Box>
          <Typography
            fontSize={20}
            color={"#323130"}
            variant="h5"
            align="center"
          >
            {t("components.cancelReservationSuccessModal.text01")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <IconButton
              onClick={() => {}}
              disableRipple={true}
              style={{
                color: "rgb(0,0,0,0)",
                width: "35px",
                height: "35px",
                backgroundColor: "#f5f5f5",
                boxShadow: "3px 3px 10px rgba(0, 0, 0, 0.2)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <RightTickIcon
                sx={{
                  alignSelf: "center",
                  backgroundColor: "#DFF6DD",
                  borderRadius: 8,
                  padding: 2,
                  height: "52px",
                  width: "52px",
                  justifyContent: "center",
                  mt: 2,
                  mb: 2,
                }}
              />
            </IconButton>
          </Box>
          <Typography
            sx={{ textAlign: "center" }}
            color={"#605E5C"}
            align="center"
          >
            {t("components.cancelReservationSuccessModal.text02")}
          </Typography>

          <Box mt={2} display={"flex"} justifyContent={"space-around"}>
            <LoadingButton
              size="small"
              sx={{ width: "150px", height: "40px" }}
              loading={false}
              color="primary"
              onClick={onConfirmClick}
              variant="contained"
            >
              {t("commonLabels.text18")}
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

CancelReservationSuccessModal.propTypes = {};

export default React.memo(CancelReservationSuccessModal);
